import { baseRequest } from '@thrivadev/thriva-request';
import { formatDataProperties } from '../utils';
import { SHOP_ORDERS_API_PATH, SHOP_ORDERS_TYPE } from './helpers';
export function patchOrder(orderId, patchShopOrderData, apiOptions) {
    const requestOptions = {
        method: 'PATCH',
        data: formatDataProperties(patchShopOrderData, SHOP_ORDERS_TYPE)
    };
    return baseRequest(`${SHOP_ORDERS_API_PATH}/${orderId}`, requestOptions, apiOptions);
}
//# sourceMappingURL=update.js.map